import { useCallback } from 'react';
import { usePenpal } from './usePenpal';
import { getHelpCenterUrl } from '../lib/utils';

/**
 * Hook for opening help center URLs using penpal's openExternalUrl
 * Works in both iframe and browser contexts
 */
export const useOpenHelpCenter = () => {
  const { openExternalUrl } = usePenpal();

  /**
   * Open a help center URL
   * @param slug - The help center slug
   * @param path - Optional path to append (defaults to '/')
   */
  const openHelpCenter = useCallback((slug: string, path: string = '/') => {
    const url = getHelpCenterUrl(slug, path);
    openExternalUrl(url);
  }, [openExternalUrl]);

  return { openHelpCenter, openExternalUrl };
};
